import { createStore } from "vuex";
import { toRaw } from "vue";
import shared from "@/shared.js";
import { v4 as uuidv4 } from "uuid";
import jwtDecode from "jwt-decode"; // Corrected import
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    jwt: "",
    persons: [{}, {}],
    fieldsets: {},
    bankInfo: {},
    responses: [],
    applications: [],
    lastApplicationGuid: "unspecified",
    applicationsFilter: {
      filter: "1",
      search: "",
      mode: "more",
      sortMode: "desc",
      sortType: "date",
      identity_method: "",
      marketing_opt_in: "",
    },
    betrag: 0, // Added betrag state
  },
  getters: {
    getResponses(state) {
      return state.responses;
    },
    getJwt(state) {
      return state.jwt;
    },
    isGermanAccountCreation(state) {
      try {
        if (state.persons[0].country.toUpperCase() == "DE") {
          return true;
        }
        return false;
      } catch (e) {
        console.log("Assuming it's not german, because of this bug:");
        console.log(e);
        return false;
      }
    },
    getJwtDecoded(state) {
      return jwtDecode(state.jwt); // Corrected usage to jwtDecode
    },
    getApplication: (state) => (guid) => {
      let application = shared.getObjectViaId(state.applications, guid);
      console.log(application);
      return application;
    },
    getBetrag(state) {
      return state.betrag; // Getter for betrag
    },
  },
  mutations: {
    setPerson(state, person) {
      state.previewPerson1 = person;
    },
    setJwt(state, jwt) {
      state.jwt = jwt;
    },
    addResponse(state, response) {
      state.responses.push({
        guid: response.id,
        message: response.message,
        success: Boolean(response.success),
        time: response.time,
      });
    },
    removeResponse(state, guid) {
      console.log("Removing response...");
      let tempResponses = toRaw(state.responses);
      state.responses = [];
      state.responses = shared.removeObjectWithId(tempResponses, guid);
    },
    setBetrag(state, value) {
      state.betrag = value; // Mutation to set betrag
    },
  },
  actions: {
    async newResponse({ commit }, res) {
      console.log("Text:" + res.message, res.success, res.time);
      res.id = uuidv4();

      commit("addResponse", res);
      let msSleep = 7500;
      if (res.time) {
        msSleep = Number(res.time);
      }
      await shared.sleep(msSleep);
      commit("removeResponse", res.id);
    },
  },
  modules: {},
  plugins: [createPersistedState()],
});
